import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom'; // Import useNavigate for redirection
import "./InterestsPage.css";
import DashboardLayout from '../Dashboard/layout';
import { Headings } from '../RegisteredUsersList/ViewRegList';
import { Form } from 'react-bootstrap';

const AddInterestsPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    status: '',
    image: null  
  });



  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  // Handle image input change
  const handleImageChange = (e) => {
    const file = e.target.files[0];  // Get the first file
    if (file) {
      setFormData({
        ...formData,
        image: file
      });
    }
  };


  // Form validation function
  const validateForm = () => {
    const errors = {};
    if (!formData.name) errors.name = 'Name is required';
    if (!formData.status) errors.status = 'Status is required';
    if (!formData.image) errors.image = 'Image is required';
    return errors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate the form
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      Swal.fire('Error', 'Please fill in all required fields', 'error');
      return;
    }

    try {
      const form = new FormData();
      form.append('name', formData.name);
      form.append('status', formData.status);
      form.append('image', formData.image); // Append image to FormData
     // console.log("interestsd222222===>>>", formData.image);
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}api/admin/interests`, // Your API URL here
        form,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
     // console.log("interestsd222222===>>>", res);

      if (res.data.status === 0) {
        Swal.fire({
          title: 'Error',
          text: 'Interests name already exists!',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          title: 'Success',
          text: 'New interests added successfully!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
        navigate("/interests"); // Redirect after success
      }
    } catch (error) {
      console.error('Error submitting data', error);
      if (error.response) {
        Swal.fire(
          'Error',
          error.response.data.message || 'Something went wrong. Please try again.',
          'error'
        );
      } else if (error.request) {
        Swal.fire('Error', 'Unable to reach the server. Please check your internet connection.', 'error');
      } else {
        Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
      }
    }
  };

  return (
    <DashboardLayout>

      <section className="MainDivSec">

        <Headings headspan="Add" hedtext=" Interests " />

        <div className="AdduserFormDiv">

          <Form onSubmit={handleSubmit}>

            <div className="FormGroupDiv">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleInputChange}
                placeholder="Enter Interests name"
                required
              />
            </div>

            <div className="FormGroupDiv">
              <label htmlFor="name">Status:</label>
              <select
                id="status"
                name="status"
                value={formData.status}
                onChange={handleInputChange}
                required >
                <option value="">Select status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
            </div>

            <div className="FormGroupDiv">
              <label htmlFor="name">Upload Icon Image:</label>
              <input
                type="file"
                id="image"
                name="image"
                accept="image/*" // Ensures only image files can be selected
                onChange={handleImageChange}
                required
              />
            </div>

            {/* {imagePreview && (
              <div className="image-preview">
                <p>Image Preview:</p>
                <img
                  src={imagePreview}
                  alt="Image Preview"
                  style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                />
              </div>
              )} */}

            <div className="SubMit">
              <button type="submit" >Add Interests</button>
            </div>

          </Form>

        </div>

      </section>

    </DashboardLayout>
  );
};

export default AddInterestsPage;
